import axios, { AxiosInstance } from 'axios';

// 环境配置
const ENV_CONFIG = {
    // 开发环境：使用 Vite 代理，相对路径即可
    development: '',
    // 生产环境：直接访问后端服务器（包含 /travel-serve 前缀）
    production: import.meta.env.VITE_API_URL || '',
};

// 获取当前环境
const getCurrentEnv = (): 'development' | 'production' => {
    return import.meta.env.DEV ? 'development' : 'production';
};

// 创建axios实例（不带拦截器，登录接口不需要token）
const authRequest: AxiosInstance = axios.create({
    baseURL: ENV_CONFIG[getCurrentEnv()],
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 响应拦截器（只处理响应格式）
authRequest.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.code === 0 || res.code === 200) {
            return res.data;
        } else {
            return Promise.reject(new Error(res.msg || '请求失败'));
        }
    },
    (error) => {
        return Promise.reject(error);
    },
);

// ==================== 类型定义 ====================

/**
 * 登录请求参数
 */
export interface LoginDTO {
    username: string;
    password: string;
}

/**
 * 登录响应数据
 */
export interface LoginVO {
    token: string;
    adminId: number;
    username: string;
    realName: string;
    phone: string;
    email: string;
}

// ==================== 认证接口 ====================

/**
 * 管理员登录
 */
export const login = (data: LoginDTO) => {
    return authRequest.post<any, LoginVO>('/admin/login', data);
};

/**
 * 检查是否已登录
 */
export const isLoggedIn = (): boolean => {
    const token = localStorage.getItem('token');
    return !!token;
};

/**
 * 退出登录
 */
export const logout = async () => {
    try {
        const token = localStorage.getItem('token');
        if (token) {
            await authRequest.post('/admin/logout', null, {
                headers: { Authorization: `Bearer ${token}` },
            });
        }
    } catch {
        // 即使后端调用失败也继续清除本地状态
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
};

export default authRequest;
